export enum AppOutcome {
  NotCompatible = 'not-compatible',
  Compatible = 'success',
  InfoNeeded = 'info-needed',
}
